import { render, staticRenderFns } from "./gdnaturalLayout.vue?vue&type=template&id=1cdd0103&"
import script from "./gdnaturalLayout.vue?vue&type=script&lang=ts&"
export * from "./gdnaturalLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports